import {
    FileCopy as ContentCopy,
    CloudDownload as Download,
    Facebook,
    Share,
} from "@mui/icons-material";
import { Box, Button, Menu, MenuItem, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { FacebookShareButton } from "react-share";
import { downloadSVGAsImage, generateImageUrl } from "../../../utils/urls";

import PropTypes from "prop-types";
import { useAppContext } from "../../../contexts/AppContext";

const ShareButton = ({
    generateShareUrl,
    svgRef,
    shareDescription,
    filename,
}) => {
    const [shareAnchorEl, setShareAnchorEl] = useState(null);
    const [shareUrl, setShareUrl] = useState("https://example.com");
    // eslint-disable-next-line no-unused-vars
    const [shareImageUrl, setShareImageUrl] = useState(
        "https://example.com/image.jpg"
    );

    const isShareOpen = Boolean(shareAnchorEl);

    const { showSnackbar } = useAppContext();

    const handleShareClick = (event) => {
        setShareAnchorEl(event.currentTarget);
        Promise.all([
            generateShareUrl(),
            generateImageUrl(svgRef.current),
        ]).then(([url, imageUrl]) => {
            setShareUrl(url);
            setShareImageUrl(imageUrl);
        });
    };

    const handleShareClose = () => {
        setShareAnchorEl(null);
    };

    const handleDownloadClick = () => {
        // determine current view and colors
        downloadSVGAsImage(svgRef?.current, filename, "png");
        handleShareClose();
    };

    const handleCopyClick = () => {
        navigator.clipboard.writeText(shareUrl);
        showSnackbar("Design URL copied to clipboard!", "success");
        handleShareClose();
    };

    return (
        <Box>
            <Button
                variant="contained"
                color="primary"
                startIcon={<Share />}
                id="share-button2"
                aria-controls={isShareOpen ? "share-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={isShareOpen ? "true" : undefined}
                onClick={handleShareClick}
                data-testid="share-button"
            >
                Share Design
            </Button>
            <Menu
                id="share-menu2"
                anchorEl={shareAnchorEl}
                open={isShareOpen}
                onClose={handleShareClose}
                MenuListProps={{
                    "aria-labelledby": "share-button2",
                }}
                data-testid="share-menu"
            >
                <MenuItem
                    onClick={handleShareClose}
                    data-testid="facebook-share-menu-item"
                >
                    <FacebookShareButton
                        url={shareUrl}
                        quote={shareDescription}
                    >
                        <Stack direction="row" gap={1} alignItems="center">
                            <Facebook />
                            <Typography variant="inherit" noWrap>
                                Facebook
                            </Typography>
                        </Stack>
                    </FacebookShareButton>
                </MenuItem>
                <MenuItem
                    onClick={handleDownloadClick}
                    data-testid="download-menu-item"
                >
                    <Stack direction="row" gap={1} alignItems="center">
                        <Download />
                        <Typography variant="inherit" noWrap>
                            Download image
                        </Typography>
                    </Stack>
                </MenuItem>
                <MenuItem
                    onClick={handleCopyClick}
                    data-testid="copy-url-menu-item"
                >
                    <Stack direction="row" gap={1} alignItems="center">
                        <ContentCopy />
                        <Typography variant="inherit" noWrap>
                            Copy design url
                        </Typography>
                    </Stack>
                </MenuItem>
            </Menu>
        </Box>
    );
};

ShareButton.propTypes = {
    generateShareUrl: PropTypes.func.isRequired,
    svgRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
        .isRequired,
    shareDescription: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
};

export default ShareButton;
